import useFeatureFlags from '~/hooks/useFeatureFlags'

export const withFeatureFlags = Component => props => {
  const [featureFlags] = useFeatureFlags()

  return <Component {...props} featureFlags={featureFlags} />
}
